import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MarkdownContent } from '../components/MarkdownContent';
import { useMarkdown } from '../hooks/useMarkdown';
import { usePlatform } from '../hooks/usePlatform';

export const HomePage: React.FC = () => {
  const { content, loading, error } = useMarkdown('home-page.md');
  const { setPlatform } = usePlatform();
  const navigate = useNavigate();

  const handlePlatformSelect = (selectedPlatform: 'ios' | 'android') => {
    setPlatform(selectedPlatform);
    // Immediately redirect to the first step
    navigate('/obezbedi');
  };

  return (
    <>
      {/* Full-width intro section with background image */}
      <div className='homepage-hero'>
        <img
          src='./images/ns.jpg'
          alt='Background'
          className='homepage-background'
        />
        <div className='homepage-hero-content'>
          <h1 className='title font-display'>Pumpaj!</h1>
          <div className='pusher'></div>
          <div className='text-body-large font-display'>
            <p className='text-intro'>
              Ovaj vodič vas neće spasiti od batinaša.
            </p>
            <p className='text-intro'> Ovaj vodič neće spasiti vaš telefon.</p>
            <p className='text-intro'>
              Ovaj vodič će vam pomoći da to ne bude uzalud.
            </p>
          </div>
        </div>
      </div>

      {/* Content section */}
      <div className='content-wrapper'>
        <div className='card card-padding'>
          <MarkdownContent content={content} loading={loading} error={error} />

          {/* Platform selection */}
          <div className='platform-selection'>
            <h3 className='font-sans font-black text-3xl pb-4'>
              Koji telefon imate?
            </h3>
            <div className='btn-group'>
              <button
                onClick={() => handlePlatformSelect('ios')}
                className='btn btn-secondary cursor-pointer'
              >
                iOS (iPhone)
              </button>
              <button
                onClick={() => handlePlatformSelect('android')}
                className='btn btn-secondary cursor-pointer'
              >
                Android
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
